import { useId, useState } from "react";
import { connect, ResolveThunks } from "react-redux";
import { RootState } from "state/rootReducer";
import Modal from "components/Modal";
import { ExportIcon, ICON_STROKE } from "shared/icons";

export type ExportPlaylistParams = {
  description: string;
  playlistName: string;
  public: boolean;
  collab: boolean;
};

interface OwnProps {
  songCount: number;
  descriptionHint: string;
  onExport: (params: ExportPlaylistParams) => void;
  onCancel: () => void;
}

interface StateProps {}

interface DispatchProps {}

export type ExportPlaylistModalProps = OwnProps &
  StateProps &
  ResolveThunks<DispatchProps>;

function ExportPlaylistModal(props: ExportPlaylistModalProps): JSX.Element {
  const [playlistName, setPlaylistName] = useState(
    `My Vybe Playlist from ${new Date().toDateString()}`
  );
  const [description, setDescription] = useState(`${props.descriptionHint}`);
  const [isPublic, setPublic] = useState(false);
  const [collab, setCollab] = useState(false);

  const nameId = useId();
  const descriptionId = useId();

  return (
    <Modal
      title="Export to Spotify"
      subtitle={`Creates a new playlist in your Spotify library with ${
        props.songCount
      } ${props.songCount === 1 ? "track" : "tracks"}.`}
      onCancel={props.onCancel}
      footer={
        <>
          <button
            type="button"
            className="button-generic"
            onClick={() => props.onCancel()}
          >
            Cancel
          </button>
          {/* A Spotify action, so it takes Spotify green. */}
          <button
            type="button"
            className="button-spotify flex items-center gap-2"
            onClick={() =>
              props.onExport({
                public: isPublic,
                playlistName,
                collab,
                description,
              })
            }
          >
            <ExportIcon
              size={16}
              strokeWidth={ICON_STROKE}
              aria-hidden="true"
            />
            Export playlist
          </button>
        </>
      }
    >
      <div className="flex flex-col gap-4">
        <div className="flex flex-col gap-1.5">
          <label htmlFor={nameId} className="text-sm font-medium text-ink-2">
            Playlist name
          </label>
          <input
            id={nameId}
            className="field-input"
            type="text"
            value={playlistName}
            onChange={(e) => setPlaylistName(e.target.value)}
          />
        </div>

        <div className="flex flex-col gap-1.5">
          <label
            htmlFor={descriptionId}
            className="text-sm font-medium text-ink-2"
          >
            Description
          </label>
          <input
            id={descriptionId}
            className="field-input"
            type="text"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
          />
        </div>

        <fieldset className="flex flex-col gap-3 border-0 p-0 m-0">
          <legend className="sr-only">Playlist options</legend>
          <label className="flex items-start gap-3 cursor-pointer">
            <input
              type="checkbox"
              className="mt-0.5 w-4 h-4 flex-none"
              checked={isPublic}
              onChange={(e) => setPublic(e.target.checked)}
            />
            <span>
              <span className="block text-sm text-ink">Public</span>
              <span className="block text-xs text-muted">
                Visible on your Spotify profile.
              </span>
            </span>
          </label>
          <label className="flex items-start gap-3 cursor-pointer">
            <input
              type="checkbox"
              className="mt-0.5 w-4 h-4 flex-none"
              checked={collab}
              onChange={(e) => setCollab(e.target.checked)}
            />
            <span>
              <span className="block text-sm text-ink">Collaborative</span>
              <span className="block text-xs text-muted">
                People you share it with can add tracks.
              </span>
            </span>
          </label>
        </fieldset>
      </div>
    </Modal>
  );
}

function mapState(_rootState: RootState): StateProps {
  return {};
}

const mapDispatch: DispatchProps = {};

export default connect(mapState, mapDispatch)(ExportPlaylistModal);
